import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "公告", -1);

var _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("h4", null, [_createElementVNode("span", {
    innerHTML: _ctx.notice
  }, null, 8, _hoisted_2)])], 64);
}